<template>
    <div class="ku-apply">
        <div class="word">
            <span>非常重要的资金安全</span>
            <label>由中国领先的持牌支付科技公司汇付天下提供支付结算，标准费率0.38%，T+1自动到账，安全又稳定。<br><font>不需要汇付支付的，可以自备pos，只能用收银及厨显功能</font></label>
        </div>
        <div class="top">
            <span :class="{'action': row.entry_mer_type === 1}" @click="row.entry_mer_type = 1">店铺申请企业</span>
            <span :class="{'action': row.entry_mer_type === 2}" @click="row.entry_mer_type = 2">店铺申请个人</span>
            <!--            <span :class="{'action': row.entry_mer_type === 3}" @click="row.entry_mer_type = 3">只用收银/平台外卖</span>-->
        </div>
        <van-row class="content">
            <van-col span="10"><van-field v-model.trim="row.shop_name" placeholder="店铺名" /></van-col>
            <van-col span="7"><van-field v-model.trim="row.customer_email" placeholder="电子邮箱" /></van-col>
            <!-- <van-col span="7"><van-field v-model.trim="row.cont_name" placeholder="法人姓名" /></van-col> -->
            <van-col span="7"><van-field v-model.trim="row.mobile" placeholder="登录电话" /></van-col>


            <!-- <van-col span="12"><van-field v-model.trim="row.legal_idno" placeholder="法人身份证号码" /></van-col> -->

            <van-col span="12"><van-field v-model.trim="row.area_value" @click="areaShow = true" placeholder="所在地区" readonly /></van-col>
            <van-col span="12">
                <van-field class="s2" readonly v-model.trim="row.address_info.address_detail" name="地址" placeholder="请选择门店地址" >
                    <template #button>
                        <van-button size="small" @click="onShowMap" type="primary">选择地址</van-button>
                    </template>
                </van-field>
            </van-col>

            <!-- <van-col span="24" v-if="row.entry_mer_type === 1"><van-field v-model.trim="row.mer_name" placeholder="公司全称" /></van-col>
            <van-col span="10" v-if="row.entry_mer_type === 1"><van-field v-model.trim="row.license_code" placeholder="营业执照编号" /></van-col>
            <van-col span="14" v-if="row.entry_mer_type === 1"><van-field v-model.trim="row.reg_addr" placeholder="注册地址(企业要和营业执照一致)" /></van-col>
            <van-col span="24" v-if="row.entry_mer_type === 2"><van-field v-model.trim="row.reg_addr" placeholder="注册地址(企业要和营业执照一致)" /></van-col>

            <van-col class="rime" span="12" v-if="row.entry_mer_type === 1"><van-field type="number" v-model.trim="row.mer_start_valid_date" placeholder="营业执照有效期(始)" /></van-col>
            <van-col class="rime" span="12" v-if="row.entry_mer_type === 1"><van-field type="number" v-model.trim="row.mer_valid_date" placeholder="营业执照有效期(至)" /></van-col>

            <van-col class="rime" span="12">
                <van-field type="number" v-model.trim="row.legal_start_cert_id_expires" placeholder="身份证有效期（始）" />
            </van-col>
            <van-col class="rime" span="12">
                <van-field type="number" v-model.trim="row.legal_id_expires" placeholder="身份证有效期（至）" />
            </van-col> -->

            <van-col class="bank_acct" span="24">
                <span>账户类型：</span>
                <van-radio-group v-model="row.bank_acct_type" direction="horizontal">
                    <van-radio name="1">对公</van-radio>
                    <van-radio name="2">对私(法人)</van-radio>
                </van-radio-group>
            </van-col>
            <van-col span="24"><van-field v-model.trim="row.card_id_mask" placeholder="结算银行卡号" /></van-col>
            <van-col span="8"><van-field v-model.trim="bank_name" @click="bankShow = true" placeholder="所属银行" readonly /></van-col>
            <van-col span="8"><van-field v-model.trim="bank_1" @click="banksShow = true" placeholder="银行卡省市" readonly /></van-col>
            <van-col span="8"><van-field v-model.trim="bank_2" @click="banksShow = true" placeholder="银行卡地区" readonly /></van-col>
            <!--            <van-col class="ku-upload" span="24">-->
            <!--                <van-uploader :after-read="image1_afterRead" v-model="image1" upload-text="店铺门头照片" :max-count="1" :max-size="2 * 1024 * 1024" />-->
            <!--                <van-uploader :after-read="image2_afterRead" v-model="image2" upload-text="内部照片" :max-count="1" :max-size="2 * 1024 * 1024"/>-->
            <!--                <van-uploader :after-read="image3_afterRead" v-model="image3" upload-text="开户许可证" :max-count="1" :max-size="2 * 1024 * 1024"/>-->
            <!--            </van-col>-->
            <van-col class="ku-upload" span="24">
                <van-uploader :after-read="image4_afterRead" v-model="image4" upload-text="营业执照" :max-count="1" :max-size="2 * 1024 * 1024" />
                <van-uploader :after-read="image5_afterRead" v-model="image5" upload-text="食品经营许可证" :max-count="1" :max-size="2 * 1024 * 1024"/>
                <van-uploader :after-read="image1_afterRead" v-model="image1" upload-text="店铺正面照片" :max-count="1" :max-size="2 * 1024 * 1024" />
            </van-col>
            <van-col class="ku-upload" span="24">
                <van-uploader :after-read="image2_afterRead" v-model="image2" upload-text="店铺内部照片" :max-count="1" :max-size="2 * 1024 * 1024" />
                <van-uploader :after-read="image6_afterRead" v-model="image6" upload-text="身份证正面" :max-count="1" :max-size="2 * 1024 * 1024"/>
                <van-uploader :after-read="image7_afterRead" v-model="image7" upload-text="身份证反面" :max-count="1" :max-size="2 * 1024 * 1024"/>
            </van-col>
            <van-col class="ku-upload" span="24">
                <van-uploader :after-read="image8_afterRead" v-model="image8" upload-text="银行卡正面" :max-count="1" :max-size="2 * 1024 * 1024"/>
                <van-uploader :after-read="image9_afterRead" v-model="image9" upload-text="银行卡反面" :max-count="1" :max-size="2 * 1024 * 1024"/>
            </van-col>
            <!--            <van-col class="ku-upload" span="24" v-if="row.entry_mer_type === 2">-->
            <!--                <van-uploader :after-read="image4_afterRead" v-model="image4" upload-text="法人银行卡正面" :max-count="1" :max-size="2 * 1024 * 1024"/>-->
            <!--            </van-col>-->

            <!--            <van-col span="24">-->
            <!--                <van-field v-model="row.code" center placeholder="请输入短信验证码">-->
            <!--                    <template #button>-->
            <!--                        <van-button size="small" v-show="show" @click="onSms" type="primary">发送验证码</van-button>-->
            <!--                        <van-button size="small" v-show="!show" type="primary">{{ count }} s</van-button>-->
            <!--                    </template>-->
            <!--                </van-field>-->
            <!--            </van-col>-->
        </van-row>

        <van-checkbox v-model="row.checked" class="checked">
            同意并接受<a @click.stop="about(1)">《用户协议》</a>和<a @click.stop="about(2)">《隐私协议》</a>
        </van-checkbox>

        <!--        <div class="top1">-->
        <!--            <div :class="{'action': row.function_type === 1}" @click="row.function_type = 1">-->
        <!--                <span>全功能型</span>-->
        <!--                <label>汇付支付/远程点餐/自营外卖/厨显等</label>-->
        <!--            </div>-->
        <!--            <div :class="{'action': row.function_type === 2}" @click="row.function_type = 2">-->
        <!--                <span>收银现金版</span>-->
        <!--                <label>自备pos或其他支付/现金收银/厨显等</label>-->
        <!--            </div>-->
        <!--        </div>-->

        <van-popup
            v-model="show_1"
            closeable
            class="popup"
            close-icon="close"
            position="bottom"
            :style="{ height: '70%', textAlign: 'left', padding: '20px 0 0 0' }"
        >
            <div class="popup-content" v-html="about_1"></div>
        </van-popup>
        <van-popup
            v-model="show_2"
            closeable
            class="popup"
            position="bottom"
            :style="{ height: '70%', textAlign: 'left', padding: '20px 0 0 0' }"
        >
            <div class="popup-content" v-html="about_2"></div>
        </van-popup>

        <!-- 弹出地图选择(这里用的也是vant的弹出组件) -->
        <van-popup v-model="showMap" position="right" :style="{ height: '100%',width:'100%' }">
            <qq-map :map-key="mapKey" :key-name="keyName" @callback="callback" @hideMap="showMap = false"></qq-map>
            <!--               :lat="settings.store_latitude"
              :lng="settings.store_longitude" -->
        </van-popup>

        <div>
            <van-button round block type="warning" @click="onSubmit" native-type="submit" color="#ea861e">提交</van-button>
        </div>

        <van-popup v-model="areaShow" position="bottom">
            <van-area title="标题" :value="row.area" :area-list="areaList" @cancel="areaShow = false" @confirm="onArea" />
        </van-popup>

        <van-popup v-model="bankShow" position="bottom">
            <van-picker
                title="所属银行"
                show-toolbar
                :columns="bankListName"
                @confirm="onBank"
                @cancel="bankShow = false"
            />
        </van-popup>

        <van-popup v-model="banksShow" position="bottom">
            <van-picker
                title="所属银行"
                show-toolbar
                :columns="sh"
                @confirm="onBanks"
                @cancel="banksShow = false"
            />
        </van-popup>

    </div>
</template>

<script>

import Vue from 'vue';
import {Field, Button, Dialog, Uploader, Popup, Checkbox, CheckboxGroup, Col, Row, Area, Picker, RadioGroup, Radio} from 'vant';
import { areaList } from '@vant/area-data';
import bank from '../../styles/bank.json';
import sh from '../../styles/sh.json';

import QqMap from '@/components/Qqmap'
import {getCookie, setCookie} from "@/utils/auth";

Vue.use(Field).use(Button).use(Dialog).use(Popup).use(Col).use(Row)
    .use(Checkbox).use(CheckboxGroup).use(Uploader).use(Area).use(Picker)
    .use(RadioGroup).use(Radio);

export default {
    name: "Login",
    components: {
        QqMap
    },
    data() {
        return {
            areaList,
            bank: bank,
            sh: sh,
            areaShow: false,
            bankShow: false,
            banksShow: false,

            id: 0,
            type: 1,
            name: '',            // 店铺名称
            image1: [], // 营业执照
            image2: [], // 食品经营许可证
            image3: [], // 店铺门头照片
            image4: [], // 店铺门头照片
            image5: [], // 店铺门头照片
            image6: [], // 店铺门头照片
            image7: [], // 店铺门头照片
            image8: [],
            image9: [],
            code: '',
            address_info: {},
            bankListCode: [],
            bankListName: [],

            show: true,
            count: '',
            timer: null,

            about_1: '',
            about_2: '',
            show_1: false,
            show_2: false,

            showMap: false,
            mapKey: 'PYZBZ-3MLC5-5XCIM-QOCQI-GI5UJ-S4F23',
            keyName: 'kupeng',

            bank_acct_type: "2",
            bank_name: '',
            bank_1: '',
            bank_2: '',

            row: {
                entry_mer_type: 1,
                function_type: 1,
                shop_name: '',
                mer_name: '',          // 公司全称
                customer_email: '',    // 电子邮箱
                license_code: '',      // 营业执照编码
                reg_addr: '',          // 注册地址
                cust_area_code: '',
                area_value:'',
                address_info: {},
                cont_name: '',
                mobile: '',
                legal_idno: '',
                card_id_mask: '',
                bank_code: '',
                prov_code: '',
                area_code: '',
                item_image: {
                    image1: '',
                    image2: '',
                    image3: '',
                    image4: '',
                    image5: '',
                    image6: '',
                    image7: '',
                    image8: '',
                    image9: '',
                },

                mer_start_valid_date: '',
                mer_valid_date: '',
                legal_start_cert_id_expires: '',
                legal_id_expires: '',
                bank_acct_type: 2,

                code: '',
                checked: false,      // 注册协议
            }
        }
    },
    mounted() {
        this.onLoad()
    },
    watch: {
        row: {
            handler(val) {
                setCookie('shop_apply', JSON.stringify(val));
            },
            deep: true
        }
    },
    methods: {
        onLoad() {
            let that = this
            that.bank.forEach(item => {
                that.bankListCode.push(item.code)
                that.bankListName.push(item.value)
            })

            let query = this.$route.query // 获取路径上的参数
            if (query.id > 0) {
                this.$API.applyInfo({id: query.id}).then(res => {
                    var data = res.data;
                    if (data.to_status === 1) {
                        Dialog.confirm({
                            message: '店铺等待审核中',
                            showCancelButton: false
                        }).then(
                            that.$router.push('/')
                        )
                    } else if (data.to_status === 2) {
                        Dialog.confirm({
                            message: '店铺已通过审核，无需重新提交',
                            showCancelButton: false
                        }).then(
                            that.$router.push('/')
                        )
                    } else {
                        that.row = data
                        that.row.cust_area_code = data.province_id + '-' + data.city_id + '-' + data.area_id
                        that.row.area_value = areaList.province_list[data.province_id] + '-' + areaList.city_list[data.city_id] + '-' + areaList.county_list[data.area_id]
                        that.row.entry_mer_type = parseInt(data.entry_mer_type)
                        that.row.address_info = {}
                        that.row.address_info.province_id = data.province_id // 存储城市ID
                        that.row.address_info.city_id = data.city_id // 存储城市ID
                        that.row.address_info.area_id = data.area_id // 存储区域ID
                        that.row.address_info.area_info_detail = data.address // 存储地图选择的地址名称
                        that.row.address_info.address_detail = data.address // 存储地图选择的详细地址
                        that.row.address_info.address_longitude = data.lng
                        that.row.address_info.address_latitude = data.lat

                        // 所属银行
                        that.bank.forEach(item => {
                            if (item.code === data.bank_code) {
                                that.bank_name = item.value
                            }
                        })
                        // 所属银行所在地区
                        that.sh.forEach(item => {
                            if (item.value === data.prov_code) {
                                that.bank_1 = item.text
                                item.children.forEach(vo => {
                                    if (vo.value === data.area_code) {
                                        that.bank_2 = vo.text
                                    }
                                })
                            }
                        })

                        // that.image5.push({url: data.image5})
                        that.row.item_image = {
                            image1: '',
                            image2: '',
                            image3: '',
                            image4: '',
                            image5: '',
                            image6: '',
                            image7: '',
                            image8: '',
                            image9: '',
                        };
                    }
                    console.log(areaList);
                })
            } else {
                let old = getCookie('shop_apply')
                if (old) {
                    this.row = JSON.parse(old)
                }
            }

            this.$API.getAbout({type: 3}).then(res => {
                this.about_1 = res.data.content
            })
            this.$API.getAbout({type: 2}).then(res => {
                this.about_2 = res.data.content
            })

            if (query.module) {
                let lat_lng = query.latng.split(",") // 获取经纬度
                let reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则

                let addr = query.addr.match(reg)
                // console.log(lat_lng) // [23.15809,113.27209] 这个数组就是对应的经度纬度了
                // console.log(addr) // ['广东省','广州市','白云区']

                this.callback(lat_lng, addr, query)
            }
        },
        onShowMap() {
            const back = encodeURIComponent(window.location.href)
            window.location.href = `https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=${back}&key=${this.mapKey}&referer=${this.keyName}`
        },
        validator() {
            if (!this.row.checked) {
                Dialog.alert({message: '请同意并接受服务协议'})
                return false
            }
            if (!this.row.shop_name.length) {
                Dialog.alert({message: '请输入店铺名称'})
                return false;
            }
            var arr = Object.keys(this.row.address_info)
            if (!arr.length || !this.row.address_info.address_longitude || !this.row.address_info.address_latitude || !this.row.address_info.address_detail.length) {
                Dialog.alert({message: '请选择店铺位置'})
                return false;
            }
            if (!/^1[3-9]\d{9}$/.test(this.row.mobile)) {
                Dialog.alert({message: '请输入正确手机号'})
                return false
            }
            // if (!/^\d{4}$/.test(this.row.code)) {
            //     Dialog.alert({message: '请输入收到的验证码'})
            //     return false
            // }
            return true
        },
        onSms() {
            let that = this

            if (!/^1[3-9]\d{9}$/.test(this.row.mobile)) {
                Dialog.alert({message: '请输入正确手机号'})
                return false
            }

            this.$API.sendSms({
                'mobile': that.row.mobile,
                'event': 'shop_apply'
            }).then(res => {
                this.getCode()
                Dialog.alert({message: '验证码已发送，5分钟内有效' + res.data})
            })
        },
        onSubmit() {
            let _this = this
            if (this.validator()) {
                this.$API.apply(_this.row).then(res => {
                    if (res.code === 1) {
                        this.$router.push("/apply_success")
                    }
                })
            }
        },
        getCode() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },
        image1_afterRead(file, detail) {
            this.afterRead(file, detail, 'image1')
        },
        image2_afterRead(file, detail) {
            this.afterRead(file, detail, 'image2')
        },
        image3_afterRead(file, detail) {
            this.afterRead(file, detail, 'image3')
        },
        image4_afterRead(file, detail) {
            this.afterRead(file, detail, 'image4')
        },
        image5_afterRead(file, detail) {
            this.afterRead(file, detail, 'image5')
        },
        image6_afterRead(file, detail) {
            this.afterRead(file, detail, 'image6')
        },
        image7_afterRead(file, detail) {
            this.afterRead(file, detail, 'image7')
        },
        image8_afterRead(file, detail) {
            this.afterRead(file, detail, 'image8')
        },
        image9_afterRead(file, detail) {
            this.afterRead(file, detail, 'image9')
        },
        afterRead(file, detail, item) {
            file.status = 'uploading';
            file.message = '上传中...';

            let formData = new FormData();
            formData.append("file", file.file);

            this.$API.upload(formData).then(res => {
                file.status = 'done'
                this.row.item_image[item] = res.data.url
            }).catch(res => {
                file.status = 'failed'
                file.message = '上传失败'
                console.log(res)
            })
        },

        // 地图选择回调
        callback(lat_lng, areaArr, query) {
            this.row.address_info.address_latitude = lat_lng[0]
            this.row.address_info.address_longitude = lat_lng[1]

            let addr = query.addr
            areaArr.forEach(item => {
                let reg = new RegExp(item);
                addr = addr.replace(reg, "");
            });

            this.row.address_info.area_info_detail = query.name // 存储地图选择的地址名称
            this.row.address_info.address_detail = addr // 存储地图选择的详细地址
        },

        about(type) {
            if (type === 1) {
                this.show_1 = true
            }
            if (type === 2) {
                this.show_2 = true
            }
        },
        onArea(e) {
            let code = [];
            let value = [];
            e.forEach(item => {
                code.push(item.code)
                value.push(item.name)
            })
            this.row.cust_area_code = code.join('-')
            this.row.area_value = value.join('-')
            this.areaShow = false
        },
        onBank(value, index) {
            this.bank_name = value
            this.row.bank_code = this.bankListCode[index]
            this.bankShow = false
        },
        onBanks(value, index) {
            this.bank_1 = value[0]
            this.bank_2 = value[1]
            this.row.prov_code = sh[index[0]].value
            this.row.area_code = sh[index[0]].children[index[1]].value
            this.banksShow = false
        }
    },
}
</script>

<style scoped lang="less">
@import "/src/styles/base";
.ku-apply {
    padding: 30px 40px 40px;
    min-height: 100%;
    background: #50AFA7;

    .word {
        background: #fff;
        border: 1px solid #dde5e1;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        padding: 15px;
        text-align: left;
        font-size: 24px;
        span {
            color: #26a670;
            display: block;
            font-weight: 800;
            margin-bottom: 6px;
        }
        label {
            color: #5c6661;
            line-height: 1.5;
            font {
                color: #ed891e;
                display: block;
                margin-top: 6px;
            }
        }
    }
    .top {
        clear: both;
        margin: 20px 0;
        height: 50px;
        span {
            display: inline-block;
            width: 215px;
            height: 50px;
            line-height: 50px;
            background: #666;
            border-radius: 10px;
            margin-right: 10px;
            float: left;
            color: #fff;
            font-size: 24px;
            &.action {
                background: #ed891e;
            }
        }
    }

    .top1 {
        clear: both;
        margin: 20px 0;
        height: 120px;
        div {
            display: inline-block;
            width: 325px;
            height: 120px;
            line-height: 50px;
            background: #666;
            border-radius: 10px;
            margin-right: 10px;
            float: left;
            color: #fff;
            span {
                display: block;
                font-size: 28px;
                font-weight: bold;
            }
            label {
                display: block;
                line-height: 30px;
                font-size: 22px;
                padding: 0 30px;
            }
            &.action {
                background: @green1;
                color: @orange;
            }
        }
    }

    .content {
        margin-top: 30px;
        display: block;
        .van-col {
            padding: 3px;
        }
        .van-field {
            padding: 15px 10px;
        }
        .van-cell {
            margin-top: 5px;
        }
        .s2 {
            padding: 7px 10px;
        }

        .bank_acct {

            padding: 20px 0 0 0;
            span {
                color: #fff;
                font-size: 26px;
                display: inline-block;
                float: left;
            }
            .van-radio {
                /deep/ .van-radio__icon {
                    .van-icon {
                        width: 30px;
                        height: 30px;
                        font-size: 26px;
                    }
                }
                /deep/ span {
                    color: #fff;
                    margin-left: 5px;
                }
            }

        }
    }
    .logo {
        width: 180px;
        margin-bottom: 20px;
    }

    .checked {
        margin: 20px 0;
        font-size: 28px;

        /deep/ .van-checkbox__icon--round {
            font-size: 28px;

            .van-icon {
                background: #fff;
            }
        }

        /deep/ .van-checkbox__icon--checked {
            .van-icon {
                background: #50AFA7;
                border-color: #fff;
            }
        }

        /deep/ .van-checkbox__label {
            color: #fff;

            a {
                color: #ECE93B;
                margin: 0 8px;
            }
        }
    }

    .ku-upload {
        justify-content: center;
        flex: 1;

        .van-uploader {
            padding: 0;
            width: 216px;
            height: 120px;
            float: left;
            &:nth-child(2) {
                margin: 0 8px;
            }
            /deep/ .van-uploader__upload {
                width: 216px;
                height: 120px;
                margin: 0;

                .van-uploader__upload-text {
                    font-size: 24px;
                }
            }

            /deep/ .van-uploader__preview {
                .van-image {
                    width: 216px;
                    height: 120px;
                }
            }
        }
    }

    .popup {
        display: flex;
        height: 30%;
    }

    .popup-content {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
}
</style>
